import React from "react";
import { Modal } from "antd";
import { Link } from "react-router-dom";

interface RetailersModalProps {
  showModal: () => void;
  isModalVisible: boolean;
  setIsModalVisible: (visible: boolean) => void;
  buttonClassName?: string; 
  buttonTitleClassName? : string
}

const Retailers: React.FC<RetailersModalProps> = ({buttonTitleClassName, showModal, isModalVisible, setIsModalVisible, buttonClassName }) => {
  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };
  const logos = [
    "http://res.cloudinary.com/brabenjos/image/upload/v1723364757/sodastream/1723364757097.png",
    "http://res.cloudinary.com/brabenjos/image/upload/v1724930135/sodastream/1724930135427.png",
    "http://res.cloudinary.com/brabenjos/image/upload/v1724930187/sodastream/1724930187510.png",
    "http://res.cloudinary.com/brabenjos/image/upload/v1724930236/sodastream/1724930236717.png",
  ];

  const buttons = [
    {
      label: "Store Locator",
      link: "/store-locator",
    },

    {
      label: "Store Locator",
      link: "/store-locator",
    },
    {
      label: "Store Locator",
      link: "/store-locator",
    },
    {
      label: "Store Locator",
      link: "/store-locator",
    },
  ];

  return (
    <>
      <button
        onClick={showModal}
        className={buttonClassName || "bg-white border border-[#005D6E] rounded-[46px] flex items-center justify-center cursor-pointer px-4 h-[30px]"}>
        <span className={buttonTitleClassName || "text-[#005D6E] text-[12px] leading-[29px] uppercase font-bold" }>
          RETAILERS
        </span>
      </button>

      <Modal
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}>
        <h1 className="text-[#005D6E] text-[19px] font-semibold leading-[38.4px]">
          Find a retailer
        </h1>
        <div>
          <h1 className="text-[#005D6E] text-[17px] font-semibold leading-[38.4px] mt-[-20px] text-center">
            Shop Online at the following retailers:
          </h1>
        </div>

        <div className="grid grid-cols-1 gap-4">
          {logos.map((logo, index) => (
            <div
              key={index}
              className="flex items-center justify-between rounded-lg shadow-sm h-[70px] w-full p-9">
              <img
                src={logo}
                alt={`Retailer Logo ${index + 1}`}
                className="max-w-[100px] max-h-[100px] object-contain"
              />
              <Link to={buttons[index].link}>
                <button
                  className="w-full sm:w-[150px] md:w-[200px] h-[30px] text-sm sm:text-base md:text-lg text-white rounded-full bg-[#75A7AD] 
                  flex items-center justify-center hover:bg-[#005D6E] focus:outline-none px-3 py-1 sm:px-4 sm:py-2 md:px-6 md:py-3">
                  {buttons[index].label}
                </button>
              </Link>
            </div>
          ))}
        </div>
      </Modal>
    </>
  );
};

export default Retailers;
